import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { mapActions, mapState } from "pinia";
import moment from "moment";

import { useApp } from "../../App/useApp";
import config from "../../../common/config";
import { ApplicationEnum, ParentPermissionEnum, PermissionActionEnum } from "../../../enums/enums";
import { BranchesService } from "../../../services/branches-service";
import { AgencyService, IGetAgency, IGetOrganization } from "../../../services/agency.service";
import { IBranchResponse } from "../../../resources-vue/vue-interfaces/i-branch";
import { PermissionManager } from "../../../common/utilities/permission-manager";
import { useLoadingIndicator } from "../../Common/LoadingIndicator/store/useLoadingIndicator";
import { ReportService } from "../../../services/report-service";
import { IFrequencyWatchRequest } from "../../../resources-vue/vue-interfaces/i-reports";
import { HomeHealthFrequencyWatchEnableAgenciesEnum } from "../../../enums/HomeHealthFrequencyWatchEnableAgenciesEnum";

import MciLayout from "../../../resources-vue/vue-elements/MciLayout/Mcilayout.vue";
import FrequencyWatchHH from "./FrequencyWatchHH/FrequencyWatchHH.vue";
import FrequencyWatchHos from "./FrequencyWatchHos/FrequencyWatchHos.vue";

export default defineComponent({
    components: {
        FrequencyWatchHH,
        FrequencyWatchHos,
        MciLayout
    },
    data() {
        return {
            _reportService: null as ReportService,
            _branchService: null,
            _agencyService: null,
            _permissionManager: null,
            tabs: [],
            activeTab: null,
            allowedTabs: [
                ApplicationEnum.HomeCare,
                ApplicationEnum.AxxessHospiceFE,
                ApplicationEnum.AxxessPalliative,
                ApplicationEnum.AgencyCore
            ],
            organizations: [] as IGetOrganization[],
            selectOrganization: [] as IGetOrganization[],
            agencyList: [] as IGetAgency[],
            branches: [] as IBranchResponse[],
            ApplicationEnum,
            frequencyWatchEnabledAgencies: Object.values(HomeHealthFrequencyWatchEnableAgenciesEnum) as string[]
        };
    },
    async created() {
        this.showLoading(true);
        this._reportService = Container.instance.get(ReportService);
        this._agencyService = Container.instance.get(AgencyService);
        this._branchService = Container.instance.get(BranchesService);
        this._permissionManager = Container.instance.get(PermissionManager);
        this.organizations = await this._agencyService.getOrganizations();
        const organizationId = localStorage.getItem(config.organizationId);
        this.selectOrganization = this.organizations.filter((organization) => organization.id == organizationId);
        this.branches = await this._branchService.getAllBranches();
        this.agencyList = this.selectOrganization[0].agencies;
        this.agencyList = this.agencyList.map((agency) => {
            return {
                ...agency,
                id: agency.id?.split("_")[0]
            };
        });
        this.loadTabs();
        this.showLoading(false);
    },
    mounted() {
        if (!this.showFrequencyWatch) {
            this.$router.push("/help");
        }
    },
    computed: {
        ...mapState(useApp, ["showFrequencyWatch", "showHosNav", "showHHNav"])
    },
    methods: {
        ...mapActions(useLoadingIndicator, { showLoading: "SET_LOADING" }),

        handleTabChange(tab: any) {
            this.activeTab = tab.id;
        },
        async loadTabs() {
            this.tabs = [
                {
                    name: "Home Health",
                    id: ApplicationEnum.AgencyCore,
                    show: this.showHHNav
                },
                {
                    name: "Hospice",
                    id: ApplicationEnum.AxxessHospiceFE,
                    show: this.showHosNav
                }
            ];
            const hasHomeHealthFrequencyWatchEnabledAgency = this.agencyList.some((agency) =>
                this.frequencyWatchEnabledAgencies.includes(agency.id)
            );
            if (!hasHomeHealthFrequencyWatchEnabledAgency) {
                this.tabs = this.tabs.filter((tab) => tab.id !== ApplicationEnum.AgencyCore);
            }
            this.tabs = this.tabs.filter((tab) => this.agencyList.some((agency) => tab.id == agency.application));
            const allowedTab = this.tabs.find((tab) => this.allowedTabs.includes(tab.id));
            this.activeTab = allowedTab ? allowedTab.id : null;
            const schedulerViewPermissions = this._permissionManager.getPermmission(
                ParentPermissionEnum.scheduler,
                PermissionActionEnum.canView
            );

            const pastDate = moment().subtract(30, "days");
            const futureDate = moment().add(30, "days");

            let payload: IFrequencyWatchRequest = {
                Application: this.activeTab?.id,
                AccountId: "",
                UserId: "",
                LocationIds: [],
                StartDate: pastDate.format("MM/DD/YYYY"),
                EndDate: futureDate.format("MM/DD/YYYY"),
                Page: 1,
                PageLength: 10,
                TeamList: [],
                LineOfService: 1,
                IsUnder: null,
                Disciplines: [],
                Tags: [],
                SortBy: "patientLastName",
                Order: "asc",
                FrequencyStatuses: []
            };
            this.tabs.forEach((tab) => {
                if (
                    this.allowedTabs.some((allowedtab) => tab.id === allowedtab) &&
                    schedulerViewPermissions.some((permission: any) => permission.application == tab.id)
                ) {
                    let accoundIds = this.agencyList
                        .filter((agency) => agency.application === tab.id)
                        .map((x: any) => x.id);
                    payload.AccountId = accoundIds[0];
                    payload.LocationIds = this.branches
                        .filter((branch) => branch.application === tab.id)
                        .map((x: any) => x.id);
                    payload.Application = tab.id;
                    this.getFrequencyWatchData(payload);
                }
            });
        },
        async getFrequencyWatchData(payload: any) {
            const response = await this._reportService.getFrequencyWatch(payload);
            return response;
        },
        goToReportCenter() {
            this.$router.push({ name: "report-center" });
        }
    }
});
